import {
  fontFamily, fontSize, fontWeight, grayscaleColor,
} from '../../utilities/designTokens';

const defaultFontStyles = {
  fontFamily: fontFamily.sans,
  fontSize: fontSize.lg,
  fontWeight: fontWeight.medium,
  letterSpacing: '-0.5px',
  lineHeight: '1.2',
};

const controlStyles = (provided) => ({
  ...provided,
  backgroundColor: grayscaleColor.white,
  border: `0.25px solid ${grayscaleColor['86']}`,
  borderRadius: '3px',
  padding: '1.5rem 0.5rem 0 0.25rem',
});

const placeholderStyles = (provided, { selectProps: { isDisabled } }) => ({
  ...provided,
  ...defaultFontStyles,
  fontWeight: fontWeight.book,
  maxWidth: 'calc(100% - 1.5rem)',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: isDisabled ? grayscaleColor['45'] : grayscaleColor['10'],
});

const singleValueStyles = (provided) => ({
  ...provided,
  ...defaultFontStyles,
  maxWidth: 'calc(100% - 1.75rem)',
  color: grayscaleColor['10'],
});

const indicatorSeparatorStyles = (provided) => ({
  ...provided,
  backgroundColor: 'transparent',
});

const dropdownIndicatorStyles = (provided, { selectProps }) => ({
  ...provided,
  '& .cmp-tire-finder__arrow-icon': {
    transform: selectProps.menuIsOpen ? 'rotate(180deg)' : '',
  },
});

const inputStyles = (provided) => ({
  ...provided,
  ...defaultFontStyles,
  '& input': {
    lineHeight: '1.2',
  },
  '& input:focus': {
    ...defaultFontStyles,
    boxShadow: 'none !important',
  },
});

const menuStyles = (provided) => ({
  ...provided,
  zIndex: 2,
});

const optionStyles = (provided, { isFocused, isSelected }) => {
  let backgroundColor = null;
  let color = grayscaleColor['10'];
  if (isSelected) {
    backgroundColor = grayscaleColor['40'];
    color = grayscaleColor.white;
  } else if (isFocused) {
    backgroundColor = grayscaleColor['90'];
  }

  return {
    ...provided,
    backgroundColor,
    color,
    fontSize: fontSize.base,
  };
};

export const customStyles = {
  control: controlStyles,
  placeholder: placeholderStyles,
  singleValue: singleValueStyles,
  indicatorSeparator: indicatorSeparatorStyles,
  dropdownIndicator: dropdownIndicatorStyles,
  input: inputStyles,
  menu: menuStyles,
  option: optionStyles,
};
